import { useState } from 'react';

import { DEFAULT_LANGUAGE } from 'shared/enums/SitePreferences';

export const useLanguage = () => {
  const [selectedLanguage, setSelectedLanguage] = useState(DEFAULT_LANGUAGE);

  return {
    selectedLanguage,
    setSelectedLanguage,
  };
};
